/**
 * Created by Ning Jiang on 11/9/2018.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {TombstoneGameConfig} from "../../TombstoneGameConfig";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {Tombstone} from "../../Tombstone";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";

export class WinNumberText extends PIXI.Container {
    private _maxWayWidth:number = 220;

    constructor(winAmount:number, multiplier:number, way:number) {
        super();
        // winAmount = 100000000;
        // way = 11216;
        // winAmount = 10.22;
        // way = 122;
        const winNumberContainer = new PIXI.Container();
        this.addChild(winNumberContainer);
        winNumberContainer.y = -10;

        let winTotalWidth = 0;
        const winNumber = new PIXI.BitmapText(`${Tombstone.api.currency.formatValue(winAmount)}`, {
            fontName : "NumbersTombstone",
            fontSize : 10,
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        winNumber.letterSpacing = -10;
        (<PIXI.Point>winNumber.anchor).set(0, 0.5);
        winNumberContainer.addChild(winNumber);
        winNumber.updateTransform();
        winTotalWidth += winNumber.textWidth;

        if(multiplier > 1) {
            const multiplierText = new PIXI.BitmapText(`x${multiplier}`, {
                fontName : "Multipliers",
                fontSize : 10,
                tint : 0xffffff
            });
            (<PIXI.Point>multiplierText.anchor).set(1, 0.5);
            multiplierText.letterSpacing = -60;
            winNumberContainer.addChild(multiplierText);
            multiplierText.updateTransform();
            winTotalWidth += multiplierText.textWidth;
            multiplierText.x = winTotalWidth * 0.5;
        }
        winNumber.x = -winTotalWidth * 0.5;

        if(winTotalWidth > this._maxWayWidth) {
            const winScale = MathHelper.roundToDecimals(this._maxWayWidth / winTotalWidth, 2);
            winNumberContainer.scale.set(winScale);
        }

        const waysContainer = new PIXI.Container();
        this.addChild(waysContainer);
        waysContainer.y = 36;

        const waysWonNumber = new PIXI.Text(way.toString(), {
            textBaseline : "middle",
            fontFamily : "Durango Western",
            fontSize : 26,
            fill : "#ffffff",
            letterSpacing : -10,
            lineHeight: 52,
            stroke: "#0a1030",
            strokeThickness: 3
        });
        waysWonNumber.anchor.set(0, 0.5);
        waysContainer.addChild(waysWonNumber);

        const textureName:string = way === 1 ? 'WinWaysSigns/WayText' : 'WinWaysSigns/WaysText';
        const waysWonText = new PIXI.Sprite(GameResources.getTextures(textureName)[0]);
        waysWonText.anchor.set(1, 0.5);
        waysWonText.scale.set(0.7);
        waysContainer.addChild(waysWonText);

        waysWonNumber.updateTransform();
        const waysTotalWidth:number = waysWonNumber.width + waysWonText.width;
        waysWonNumber.x = -waysTotalWidth / 2;
        waysWonText.x = waysTotalWidth / 2;
        if(waysTotalWidth > this._maxWayWidth) {
            const waysScale = MathHelper.roundToDecimals(this._maxWayWidth / waysTotalWidth, 2);
            waysContainer.scale.set(waysScale);
        }
    }
}

export class TombstoneIndividualWPView extends BaseView {

    private _layer:PIXI.Container;
    private _togglesPool:TimelineSprite[];
    private _togglesDisplaying:TimelineSprite[];
    private _wildTogglesPool:TimelineSprite[];
    private _wildTogglesDisplaying:TimelineSprite[];
    private _winNumberText:WinNumberText | null;
    private _winNumberTl:TweenLite | null;

    constructor() {
        super();

        this._togglesPool = [];
        this._togglesDisplaying = [];
        this._wildTogglesPool = [];
        this._wildTogglesDisplaying = [];
        this._layer = StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.INDIVIDUAL_WIN.name);
    }

    public getToggleOverlayToTimeline(betWayWinData:IBetWayWinData, position:[number, number], isWild:boolean, showWinText:boolean):TimelineLite {
        const toggle:TimelineSprite = isWild ? this.getWildToggle() : this.getToggle();
        toggle.position.set(position[0], position[1]);

        const toggleTimeline:TimelineLite = new TimelineLite();
        toggleTimeline.add(() => {
            this._layer.addChild(toggle);
            if(showWinText) {
                this.showWinText(betWayWinData, position);
            }
        });
        toggleTimeline.add(toggle.getAnimationAutoShowHide());
        toggleTimeline.add(() => isWild ? this.removeWildToggle(toggle) : this.removeToggle(toggle));

        return toggleTimeline;
    }

    private getToggle():TimelineSprite {
        let toggle:TimelineSprite;
        if(this._togglesPool.length === 0) {
            toggle = new TimelineSprite(GameResources.getTextures("toggle"));
            toggle.blendMode = PIXI.BLEND_MODES.SCREEN;
            toggle.anchor.set(0.5, 0.5);
            toggle.hide();
        } else {
            toggle = this._togglesPool.pop()!;
        }
        this._togglesDisplaying.push(toggle);

        return toggle;
    }

    private getWildToggle():TimelineSprite {
        let wildToggle:TimelineSprite;
        if(this._wildTogglesPool.length === 0) {
            wildToggle = new TimelineSprite(GameResources.getTextures("toggleW"));
            wildToggle.blendMode = PIXI.BLEND_MODES.SCREEN;
            wildToggle.anchor.set(0.5);
            wildToggle.hide();
        } else {
            wildToggle = this._wildTogglesPool.pop()!
        }
        this._wildTogglesDisplaying.push(wildToggle);

        return wildToggle;
    }

    private removeToggle(toggle:TimelineSprite):void {
        toggle.hide();
        ArrayHelper.removeFirstMatchElement(this._togglesDisplaying, toggle);
        this._layer.removeChild(toggle);
        this._togglesPool.push(toggle);
    }

    private removeWildToggle(wildToggle:TimelineSprite):void {
        wildToggle.hide();
        ArrayHelper.removeFirstMatchElement(this._wildTogglesDisplaying, wildToggle);
        this._layer.removeChild(wildToggle);
        this._wildTogglesPool.push(wildToggle);
    }

    public stopWinPresentation():void {
        this.removeWinText();
        while(this._togglesDisplaying.length > 0) {
            this.removeToggle(this._togglesDisplaying[0]);
        }
        while(this._wildTogglesDisplaying.length > 0) {
            this.removeWildToggle(this._wildTogglesDisplaying[0]);
        }
    }

    private showWinText(betWayWinData:IBetWayWinData, position:[number, number]):void {
        this.removeWinText();
        this._winNumberText = new WinNumberText(betWayWinData.multipliedAmount, betWayWinData.multiplier, betWayWinData.numberOfCombinations);
        this._winNumberText.position.set(position[0], position[1]);
        this._winNumberText.alpha = 0;
        StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name).addChild(this._winNumberText);
        this._winNumberTl = TweenLite.to(this._winNumberText, 0.1, {alpha : 1});
    }

    private removeWinText():void {
        if(this._winNumberTl && this._winNumberTl.isActive()) {
            this._winNumberTl.progress(1);
        }
        this._winNumberTl = null;

        if(this._winNumberText) {
            if(this._winNumberText.parent) {
                this._winNumberText.parent.removeChild(this._winNumberText);
            }
            this._winNumberText.destroy();
            this._winNumberText = null;
        }
    }
}